module.exports = __webpack_public_path__ + "media/images/products/category/11-9625c8f2f551413a52edec38401cb712.jpg";